import { RandomGenerator } from '@grandom/core';
import { getRest } from '../utils';
export default class RandomObjectShuffle extends RandomGenerator {
    constructor(engine) {
        super(engine);
        this.shuffle = this.shuffle.bind(this);
    }
    // -----------------------------------------------------------------------------------------------
    canBeParsed(arg1) {
        return arg1 !== null && typeof arg1 === 'object';
    }
    parse(arg1, arg2, arg3) {
        const keys = Object.keys(arg1);
        if (keys.length < 1) {
            return {};
        }
        const { count, options } = getRest(arg1, arg2, arg3);
        const filter = typeof options.filter === 'function'
            ? options.filter
            : undefined;
        const length = count === -1
            ? keys.length
            : count;
        const pool = {};
        this._engine.shuffleArray(keys);
        for (let i = 0; i < length; i++) {
            const key = keys[i];
            const value = arg1[key];
            if (filter?.(key, value) === false) {
                continue;
            }
            pool[key] = value;
        }
        return pool;
    }
    // -----------------------------------------------------------------------------------------------
    shuffle(arg1, arg2, arg3) {
        if (this.canBeParsed(arg1)) {
            return this.parse(arg1, arg2, arg3);
        }
        throw new TypeError(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `Must be called with an object, got: ${arg1} (typeof === '${typeof arg1}').`);
    }
}
//# sourceMappingURL=index.js.map